/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

$( document ).ready(function() {
  $(".sf_level2 span.sf_nav_arrow").click(function(){
    $(".nav-item .l3").addClass("is_active");
   
  });
  
});